export default __webpack_public_path__ + "static/media/property_936.38e3874f.png";